var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26491 5.85829H11.511C12.5241 5.85829 13.183 6.92442 12.73 7.83055L10.3451 12.6003C10.1142 13.062 9.64235 13.3537 9.12616 13.3537H6.38849C6.27706 13.3537 6.16606 13.34 6.05796 13.313L3.49513 12.6723M8.26491 5.85829V2.4513C8.26491 1.69865 7.65477 1.0885 6.90212 1.0885H6.83706C6.49666 1.0885 6.22072 1.36445 6.22072 1.70484C6.22072 2.19157 6.07665 2.6674 5.80666 3.07239L3.49513 6.53969V12.6723M8.26491 5.85829H6.90212M3.49513 12.6723H2.13233C1.37968 12.6723 0.769531 12.0621 0.769531 11.3095V7.22109C0.769531 6.46844 1.37968 5.85829 2.13233 5.85829H3.83582",
    stroke: "#111827",
    strokeWidth: 1.3628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.71d1afe9a723a0122ce7b06a9afb7dfc.svg";
export { ForwardRef as ReactComponent };